const VideoBackground = () => {
    // --- ID real do vídeo extraído do link ---
    const YOUTUBE_VIDEO_ID = "T0-M-5udfrY";

    // Configurações do embed do Youtube
    const EMBED_URL = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&mute=1&loop=1&playlist=${YOUTUBE_VIDEO_ID}&controls=0&modestbranding=1&rel=0&showinfo=0&disablekb=1&iv_load_policy=3`;

    const iframeStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',

        minWidth: '100%',
        minHeight: '100%',
        marginLeft: '-1px',

        // Mantém o vídeo sempre cobrindo a tela
        width: '177.77vh',
        height: '56.25vw',

        pointerEvents: 'none',
    };

    return (
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-20">
            <iframe
                style={iframeStyle}
                src={EMBED_URL}
                frameBorder="0"
                allow="autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Vídeo de Fundo"
            ></iframe>
        </div>
    );
};

export default VideoBackground;
